import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RecommendIcon(props: IconProps) {
    return <Icon {...props} iconKey={"recommend"}/>
}
